import React from "react";

import ShellCard from "../ShellCard";

import "./styles.css";

/**
 * Card PADRÃO que agrupa os tiles de KPI (`MetricCard`) de uma página do Hub
 * (PO1-2723). Nas telas de referência os tiles nunca ficam soltos na página:
 * Faturamento usa um Card `card-everlog-shell` ("Resumo do recorte") com grid
 * de métricas no corpo; Auditoria de CT-e / Faturas usam a seção "Status" dentro
 * do card de controle. Este componente é um `ShellCard` (mesmo shell do
 * `PageHero` / `FilterBand`, cabeçalho opcional) com grid responsivo.
 *
 * Props:
 * - eyebrow, title, description, action: cabeçalho do card (opcionais; sem
 *   nenhum deles o card renderiza só o grid).
 * - minTileWidth: largura mínima de cada tile no grid (px, default 190, igual ao
 *   Faturamento). O grid é `repeat(auto-fit, minmax(minTileWidth, 1fr))`.
 * - className, style: mesclados no Card; gridStyle: mesclado no grid.
 * - children: os `MetricCard`.
 */
export default function MetricCardGroup({
  eyebrow,
  title,
  description,
  action,
  minTileWidth = 190,
  className = "",
  style,
  gridStyle,
  children,
}) {
  return (
    <ShellCard
      eyebrow={eyebrow}
      title={title}
      description={description}
      action={action}
      className={`hub-metric-group ${className}`.trim()}
      style={style}
    >
      <div
        className="hub-metric-group__grid"
        style={{ "--hub-mcg-min": `${minTileWidth}px`, ...gridStyle }}
      >
        {children}
      </div>
    </ShellCard>
  );
}
